/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createUser = /* GraphQL */ `mutation CreateUser(
  $input: CreateUserInput!
  $condition: ModelUserConditionInput
) {
  createUser(input: $input, condition: $condition) {
    id
    email
    name
    transcriptionTime
    transcriptionsCreated
    casesCreated
    templatesUsed
    currentTranscriptionsCreated
    currentCasesCreated
    currentTemplatesUsed
    storeReviewRequestedAt
    pims
    audioRetentionPeriod
    defaultNormalText
    stripeCustomerId
    groups
    owner
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const updateUser = /* GraphQL */ `mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    id
    email
    name
    transcriptionTime
    transcriptionsCreated
    casesCreated
    templatesUsed
    currentTranscriptionsCreated
    currentCasesCreated
    currentTemplatesUsed
    storeReviewRequestedAt
    pims
    audioRetentionPeriod
    defaultNormalText
    stripeCustomerId
    groups
    owner
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;
export const deleteUser = /* GraphQL */ `mutation DeleteUser(
  $input: DeleteUserInput!
  $condition: ModelUserConditionInput
) {
  deleteUser(input: $input, condition: $condition) {
    id
    email
    name
    transcriptionTime
    transcriptionsCreated
    casesCreated
    templatesUsed
    currentTranscriptionsCreated
    currentCasesCreated
    currentTemplatesUsed
    storeReviewRequestedAt
    pims
    audioRetentionPeriod
    defaultNormalText
    stripeCustomerId
    groups
    owner
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserMutationVariables,
  APITypes.DeleteUserMutation
>;
export const createLocation = /* GraphQL */ `mutation CreateLocation(
  $input: CreateLocationInput!
  $condition: ModelLocationConditionInput
) {
  createLocation(input: $input, condition: $condition) {
    id
    name
    address
    patients {
      items {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    cases {
      items {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    templates {
      items {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    recordings {
      items {
        id
        name
        storagePath
        useTemplate
        duration
        text
        segments
        summary
        lID
        cID
        dID
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    billingcodes {
      items {
        id
        code
        description
        keywords
        price
        lID
        groups
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    groupUsers
    groupAdmins
    groups
    owners
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLocationMutationVariables,
  APITypes.CreateLocationMutation
>;
export const updateLocation = /* GraphQL */ `mutation UpdateLocation(
  $input: UpdateLocationInput!
  $condition: ModelLocationConditionInput
) {
  updateLocation(input: $input, condition: $condition) {
    id
    name
    address
    patients {
      items {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    cases {
      items {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    templates {
      items {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    recordings {
      items {
        id
        name
        storagePath
        useTemplate
        duration
        text
        segments
        summary
        lID
        cID
        dID
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    billingcodes {
      items {
        id
        code
        description
        keywords
        price
        lID
        groups
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    groupUsers
    groupAdmins
    groups
    owners
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLocationMutationVariables,
  APITypes.UpdateLocationMutation
>;
export const deleteLocation = /* GraphQL */ `mutation DeleteLocation(
  $input: DeleteLocationInput!
  $condition: ModelLocationConditionInput
) {
  deleteLocation(input: $input, condition: $condition) {
    id
    name
    address
    patients {
      items {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    cases {
      items {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    templates {
      items {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    recordings {
      items {
        id
        name
        storagePath
        useTemplate
        duration
        text
        segments
        summary
        lID
        cID
        dID
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    billingcodes {
      items {
        id
        code
        description
        keywords
        price
        lID
        groups
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    groupUsers
    groupAdmins
    groups
    owners
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLocationMutationVariables,
  APITypes.DeleteLocationMutation
>;
export const createPatient = /* GraphQL */ `mutation CreatePatient(
  $input: CreatePatientInput!
  $condition: ModelPatientConditionInput
) {
  createPatient(input: $input, condition: $condition) {
    id
    name
    client
    image
    s3Image
    pinned
    archived
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    cases {
      items {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    details {
      items {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    groups
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePatientMutationVariables,
  APITypes.CreatePatientMutation
>;
export const updatePatient = /* GraphQL */ `mutation UpdatePatient(
  $input: UpdatePatientInput!
  $condition: ModelPatientConditionInput
) {
  updatePatient(input: $input, condition: $condition) {
    id
    name
    client
    image
    s3Image
    pinned
    archived
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    cases {
      items {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    details {
      items {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    groups
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePatientMutationVariables,
  APITypes.UpdatePatientMutation
>;
export const deletePatient = /* GraphQL */ `mutation DeletePatient(
  $input: DeletePatientInput!
  $condition: ModelPatientConditionInput
) {
  deletePatient(input: $input, condition: $condition) {
    id
    name
    client
    image
    s3Image
    pinned
    archived
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    cases {
      items {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    details {
      items {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    groups
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePatientMutationVariables,
  APITypes.DeletePatientMutation
>;
export const createCase = /* GraphQL */ `mutation CreateCase(
  $input: CreateCaseInput!
  $condition: ModelCaseConditionInput
) {
  createCase(input: $input, condition: $condition) {
    id
    title
    description
    historySummary
    planSummary
    communicationSummary
    overviewSummary
    typedNotes
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    caseTemplateId
    templateData
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    patient {
      id
      name
      client
      image
      s3Image
      pinned
      archived
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      cases {
        nextToken
        startedAt
        __typename
      }
      details {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    pID
    details {
      items {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    recordings {
      items {
        id
        name
        storagePath
        useTemplate
        duration
        text
        segments
        summary
        lID
        cID
        dID
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    groups
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCaseMutationVariables,
  APITypes.CreateCaseMutation
>;
export const updateCase = /* GraphQL */ `mutation UpdateCase(
  $input: UpdateCaseInput!
  $condition: ModelCaseConditionInput
) {
  updateCase(input: $input, condition: $condition) {
    id
    title
    description
    historySummary
    planSummary
    communicationSummary
    overviewSummary
    typedNotes
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    caseTemplateId
    templateData
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    patient {
      id
      name
      client
      image
      s3Image
      pinned
      archived
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      cases {
        nextToken
        startedAt
        __typename
      }
      details {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    pID
    details {
      items {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    recordings {
      items {
        id
        name
        storagePath
        useTemplate
        duration
        text
        segments
        summary
        lID
        cID
        dID
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    groups
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCaseMutationVariables,
  APITypes.UpdateCaseMutation
>;
export const deleteCase = /* GraphQL */ `mutation DeleteCase(
  $input: DeleteCaseInput!
  $condition: ModelCaseConditionInput
) {
  deleteCase(input: $input, condition: $condition) {
    id
    title
    description
    historySummary
    planSummary
    communicationSummary
    overviewSummary
    typedNotes
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    caseTemplateId
    templateData
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    patient {
      id
      name
      client
      image
      s3Image
      pinned
      archived
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      cases {
        nextToken
        startedAt
        __typename
      }
      details {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    pID
    details {
      items {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    recordings {
      items {
        id
        name
        storagePath
        useTemplate
        duration
        text
        segments
        summary
        lID
        cID
        dID
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    groups
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCaseMutationVariables,
  APITypes.DeleteCaseMutation
>;
export const createDetails = /* GraphQL */ `mutation CreateDetails(
  $input: CreateDetailsInput!
  $condition: ModelDetailsConditionInput
) {
  createDetails(input: $input, condition: $condition) {
    id
    type
    text
    summary
    isSummarized
    patient {
      id
      name
      client
      image
      s3Image
      pinned
      archived
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      cases {
        nextToken
        startedAt
        __typename
      }
      details {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    pID
    case {
      id
      title
      description
      historySummary
      planSummary
      communicationSummary
      overviewSummary
      typedNotes
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      caseTemplateId
      templateData
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      details {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    cID
    recording {
      id
      name
      storagePath
      useTemplate
      duration
      text
      segments
      summary
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      case {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      cID
      details {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      dID
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    groups
    owners
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    detailsRecordingId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDetailsMutationVariables,
  APITypes.CreateDetailsMutation
>;
export const updateDetails = /* GraphQL */ `mutation UpdateDetails(
  $input: UpdateDetailsInput!
  $condition: ModelDetailsConditionInput
) {
  updateDetails(input: $input, condition: $condition) {
    id
    type
    text
    summary
    isSummarized
    patient {
      id
      name
      client
      image
      s3Image
      pinned
      archived
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      cases {
        nextToken
        startedAt
        __typename
      }
      details {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    pID
    case {
      id
      title
      description
      historySummary
      planSummary
      communicationSummary
      overviewSummary
      typedNotes
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      caseTemplateId
      templateData
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      details {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    cID
    recording {
      id
      name
      storagePath
      useTemplate
      duration
      text
      segments
      summary
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      case {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      cID
      details {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      dID
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    groups
    owners
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    detailsRecordingId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDetailsMutationVariables,
  APITypes.UpdateDetailsMutation
>;
export const deleteDetails = /* GraphQL */ `mutation DeleteDetails(
  $input: DeleteDetailsInput!
  $condition: ModelDetailsConditionInput
) {
  deleteDetails(input: $input, condition: $condition) {
    id
    type
    text
    summary
    isSummarized
    patient {
      id
      name
      client
      image
      s3Image
      pinned
      archived
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      cases {
        nextToken
        startedAt
        __typename
      }
      details {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    pID
    case {
      id
      title
      description
      historySummary
      planSummary
      communicationSummary
      overviewSummary
      typedNotes
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      caseTemplateId
      templateData
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      details {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    cID
    recording {
      id
      name
      storagePath
      useTemplate
      duration
      text
      segments
      summary
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      case {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      cID
      details {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      dID
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    groups
    owners
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    detailsRecordingId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDetailsMutationVariables,
  APITypes.DeleteDetailsMutation
>;
export const createRecording = /* GraphQL */ `mutation CreateRecording(
  $input: CreateRecordingInput!
  $condition: ModelRecordingConditionInput
) {
  createRecording(input: $input, condition: $condition) {
    id
    name
    storagePath
    useTemplate
    duration
    text
    segments
    summary
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    case {
      id
      title
      description
      historySummary
      planSummary
      communicationSummary
      overviewSummary
      typedNotes
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      caseTemplateId
      templateData
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      details {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    cID
    details {
      id
      type
      text
      summary
      isSummarized
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      case {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      cID
      recording {
        id
        name
        storagePath
        useTemplate
        duration
        text
        segments
        summary
        lID
        cID
        dID
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      detailsRecordingId
      __typename
    }
    dID
    owners
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRecordingMutationVariables,
  APITypes.CreateRecordingMutation
>;
export const updateRecording = /* GraphQL */ `mutation UpdateRecording(
  $input: UpdateRecordingInput!
  $condition: ModelRecordingConditionInput
) {
  updateRecording(input: $input, condition: $condition) {
    id
    name
    storagePath
    useTemplate
    duration
    text
    segments
    summary
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    case {
      id
      title
      description
      historySummary
      planSummary
      communicationSummary
      overviewSummary
      typedNotes
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      caseTemplateId
      templateData
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      details {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    cID
    details {
      id
      type
      text
      summary
      isSummarized
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      case {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      cID
      recording {
        id
        name
        storagePath
        useTemplate
        duration
        text
        segments
        summary
        lID
        cID
        dID
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      detailsRecordingId
      __typename
    }
    dID
    owners
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRecordingMutationVariables,
  APITypes.UpdateRecordingMutation
>;
export const deleteRecording = /* GraphQL */ `mutation DeleteRecording(
  $input: DeleteRecordingInput!
  $condition: ModelRecordingConditionInput
) {
  deleteRecording(input: $input, condition: $condition) {
    id
    name
    storagePath
    useTemplate
    duration
    text
    segments
    summary
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    case {
      id
      title
      description
      historySummary
      planSummary
      communicationSummary
      overviewSummary
      typedNotes
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      caseTemplateId
      templateData
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      details {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    cID
    details {
      id
      type
      text
      summary
      isSummarized
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      case {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      cID
      recording {
        id
        name
        storagePath
        useTemplate
        duration
        text
        segments
        summary
        lID
        cID
        dID
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      detailsRecordingId
      __typename
    }
    dID
    owners
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRecordingMutationVariables,
  APITypes.DeleteRecordingMutation
>;
export const createBillingCodes = /* GraphQL */ `mutation CreateBillingCodes(
  $input: CreateBillingCodesInput!
  $condition: ModelBillingCodesConditionInput
) {
  createBillingCodes(input: $input, condition: $condition) {
    id
    code
    description
    keywords
    price
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    groups
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBillingCodesMutationVariables,
  APITypes.CreateBillingCodesMutation
>;
export const updateBillingCodes = /* GraphQL */ `mutation UpdateBillingCodes(
  $input: UpdateBillingCodesInput!
  $condition: ModelBillingCodesConditionInput
) {
  updateBillingCodes(input: $input, condition: $condition) {
    id
    code
    description
    keywords
    price
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    groups
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBillingCodesMutationVariables,
  APITypes.UpdateBillingCodesMutation
>;
export const deleteBillingCodes = /* GraphQL */ `mutation DeleteBillingCodes(
  $input: DeleteBillingCodesInput!
  $condition: ModelBillingCodesConditionInput
) {
  deleteBillingCodes(input: $input, condition: $condition) {
    id
    code
    description
    keywords
    price
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    groups
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBillingCodesMutationVariables,
  APITypes.DeleteBillingCodesMutation
>;
export const createTemplate = /* GraphQL */ `mutation CreateTemplate(
  $input: CreateTemplateInput!
  $condition: ModelTemplateConditionInput
) {
  createTemplate(input: $input, condition: $condition) {
    id
    name
    pinned
    archived
    advanced
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    sections {
      items {
        id
        name
        isSimple
        tID
        subsectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    sectionOrder
    subsections {
      items {
        id
        name
        sID
        fieldOrder
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    fields {
      items {
        id
        name
        value
        ssID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    textboxes {
      items {
        id
        value
        sID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTemplateMutationVariables,
  APITypes.CreateTemplateMutation
>;
export const updateTemplate = /* GraphQL */ `mutation UpdateTemplate(
  $input: UpdateTemplateInput!
  $condition: ModelTemplateConditionInput
) {
  updateTemplate(input: $input, condition: $condition) {
    id
    name
    pinned
    archived
    advanced
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    sections {
      items {
        id
        name
        isSimple
        tID
        subsectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    sectionOrder
    subsections {
      items {
        id
        name
        sID
        fieldOrder
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    fields {
      items {
        id
        name
        value
        ssID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    textboxes {
      items {
        id
        value
        sID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTemplateMutationVariables,
  APITypes.UpdateTemplateMutation
>;
export const deleteTemplate = /* GraphQL */ `mutation DeleteTemplate(
  $input: DeleteTemplateInput!
  $condition: ModelTemplateConditionInput
) {
  deleteTemplate(input: $input, condition: $condition) {
    id
    name
    pinned
    archived
    advanced
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    sections {
      items {
        id
        name
        isSimple
        tID
        subsectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    sectionOrder
    subsections {
      items {
        id
        name
        sID
        fieldOrder
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    fields {
      items {
        id
        name
        value
        ssID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    textboxes {
      items {
        id
        value
        sID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTemplateMutationVariables,
  APITypes.DeleteTemplateMutation
>;
export const createTemplateSection = /* GraphQL */ `mutation CreateTemplateSection(
  $input: CreateTemplateSectionInput!
  $condition: ModelTemplateSectionConditionInput
) {
  createTemplateSection(input: $input, condition: $condition) {
    id
    name
    isSimple
    textboxes {
      items {
        id
        value
        sID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    subsections {
      items {
        id
        name
        sID
        fieldOrder
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    subsectionOrder
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTemplateSectionMutationVariables,
  APITypes.CreateTemplateSectionMutation
>;
export const updateTemplateSection = /* GraphQL */ `mutation UpdateTemplateSection(
  $input: UpdateTemplateSectionInput!
  $condition: ModelTemplateSectionConditionInput
) {
  updateTemplateSection(input: $input, condition: $condition) {
    id
    name
    isSimple
    textboxes {
      items {
        id
        value
        sID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    subsections {
      items {
        id
        name
        sID
        fieldOrder
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    subsectionOrder
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTemplateSectionMutationVariables,
  APITypes.UpdateTemplateSectionMutation
>;
export const deleteTemplateSection = /* GraphQL */ `mutation DeleteTemplateSection(
  $input: DeleteTemplateSectionInput!
  $condition: ModelTemplateSectionConditionInput
) {
  deleteTemplateSection(input: $input, condition: $condition) {
    id
    name
    isSimple
    textboxes {
      items {
        id
        value
        sID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    subsections {
      items {
        id
        name
        sID
        fieldOrder
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    subsectionOrder
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTemplateSectionMutationVariables,
  APITypes.DeleteTemplateSectionMutation
>;
export const createTemplateTextbox = /* GraphQL */ `mutation CreateTemplateTextbox(
  $input: CreateTemplateTextboxInput!
  $condition: ModelTemplateTextboxConditionInput
) {
  createTemplateTextbox(input: $input, condition: $condition) {
    id
    value
    section {
      id
      name
      isSimple
      textboxes {
        nextToken
        startedAt
        __typename
      }
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      subsections {
        nextToken
        startedAt
        __typename
      }
      subsectionOrder
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    sID
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTemplateTextboxMutationVariables,
  APITypes.CreateTemplateTextboxMutation
>;
export const updateTemplateTextbox = /* GraphQL */ `mutation UpdateTemplateTextbox(
  $input: UpdateTemplateTextboxInput!
  $condition: ModelTemplateTextboxConditionInput
) {
  updateTemplateTextbox(input: $input, condition: $condition) {
    id
    value
    section {
      id
      name
      isSimple
      textboxes {
        nextToken
        startedAt
        __typename
      }
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      subsections {
        nextToken
        startedAt
        __typename
      }
      subsectionOrder
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    sID
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTemplateTextboxMutationVariables,
  APITypes.UpdateTemplateTextboxMutation
>;
export const deleteTemplateTextbox = /* GraphQL */ `mutation DeleteTemplateTextbox(
  $input: DeleteTemplateTextboxInput!
  $condition: ModelTemplateTextboxConditionInput
) {
  deleteTemplateTextbox(input: $input, condition: $condition) {
    id
    value
    section {
      id
      name
      isSimple
      textboxes {
        nextToken
        startedAt
        __typename
      }
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      subsections {
        nextToken
        startedAt
        __typename
      }
      subsectionOrder
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    sID
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTemplateTextboxMutationVariables,
  APITypes.DeleteTemplateTextboxMutation
>;
export const createTemplateSubsection = /* GraphQL */ `mutation CreateTemplateSubsection(
  $input: CreateTemplateSubsectionInput!
  $condition: ModelTemplateSubsectionConditionInput
) {
  createTemplateSubsection(input: $input, condition: $condition) {
    id
    name
    section {
      id
      name
      isSimple
      textboxes {
        nextToken
        startedAt
        __typename
      }
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      subsections {
        nextToken
        startedAt
        __typename
      }
      subsectionOrder
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    sID
    fields {
      items {
        id
        name
        value
        ssID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    fieldOrder
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTemplateSubsectionMutationVariables,
  APITypes.CreateTemplateSubsectionMutation
>;
export const updateTemplateSubsection = /* GraphQL */ `mutation UpdateTemplateSubsection(
  $input: UpdateTemplateSubsectionInput!
  $condition: ModelTemplateSubsectionConditionInput
) {
  updateTemplateSubsection(input: $input, condition: $condition) {
    id
    name
    section {
      id
      name
      isSimple
      textboxes {
        nextToken
        startedAt
        __typename
      }
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      subsections {
        nextToken
        startedAt
        __typename
      }
      subsectionOrder
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    sID
    fields {
      items {
        id
        name
        value
        ssID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    fieldOrder
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTemplateSubsectionMutationVariables,
  APITypes.UpdateTemplateSubsectionMutation
>;
export const deleteTemplateSubsection = /* GraphQL */ `mutation DeleteTemplateSubsection(
  $input: DeleteTemplateSubsectionInput!
  $condition: ModelTemplateSubsectionConditionInput
) {
  deleteTemplateSubsection(input: $input, condition: $condition) {
    id
    name
    section {
      id
      name
      isSimple
      textboxes {
        nextToken
        startedAt
        __typename
      }
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      subsections {
        nextToken
        startedAt
        __typename
      }
      subsectionOrder
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    sID
    fields {
      items {
        id
        name
        value
        ssID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    fieldOrder
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTemplateSubsectionMutationVariables,
  APITypes.DeleteTemplateSubsectionMutation
>;
export const createTemplateField = /* GraphQL */ `mutation CreateTemplateField(
  $input: CreateTemplateFieldInput!
  $condition: ModelTemplateFieldConditionInput
) {
  createTemplateField(input: $input, condition: $condition) {
    id
    name
    value
    subsection {
      id
      name
      section {
        id
        name
        isSimple
        tID
        subsectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sID
      fields {
        nextToken
        startedAt
        __typename
      }
      fieldOrder
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ssID
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTemplateFieldMutationVariables,
  APITypes.CreateTemplateFieldMutation
>;
export const updateTemplateField = /* GraphQL */ `mutation UpdateTemplateField(
  $input: UpdateTemplateFieldInput!
  $condition: ModelTemplateFieldConditionInput
) {
  updateTemplateField(input: $input, condition: $condition) {
    id
    name
    value
    subsection {
      id
      name
      section {
        id
        name
        isSimple
        tID
        subsectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sID
      fields {
        nextToken
        startedAt
        __typename
      }
      fieldOrder
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ssID
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTemplateFieldMutationVariables,
  APITypes.UpdateTemplateFieldMutation
>;
export const deleteTemplateField = /* GraphQL */ `mutation DeleteTemplateField(
  $input: DeleteTemplateFieldInput!
  $condition: ModelTemplateFieldConditionInput
) {
  deleteTemplateField(input: $input, condition: $condition) {
    id
    name
    value
    subsection {
      id
      name
      section {
        id
        name
        isSimple
        tID
        subsectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sID
      fields {
        nextToken
        startedAt
        __typename
      }
      fieldOrder
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ssID
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTemplateFieldMutationVariables,
  APITypes.DeleteTemplateFieldMutation
>;
